import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { setChatOpen } from '@widgets/Common/GigAssist/model/slice'

export const useAssistOpen = ({ isAssistOpen }) => {
  const searchParams = useSearchParams()
  const isOpen = useAppSelector((store) => store.gigAssist.chatOpen)
  const dispatch = useAppDispatch()

  // проверяем параметр при монтировании
  useEffect(() => {
    const isAssistOpenParam = searchParams.get(isAssistOpen)
    if (isAssistOpenParam === 'true') {
      dispatch(setChatOpen(true))
    } else {
      dispatch(setChatOpen(false))
    }
  }, [searchParams])

  // обновляем URL при изменении состояния
  const handleSetIsOpen = (value: boolean) => {
    dispatch(setChatOpen(value))

    const url = new URL(window.location.href)
    if (value) {
      url.searchParams.set(isAssistOpen, 'true')
    } else {
      url.searchParams.delete(isAssistOpen)
    }

    window.history.replaceState({}, '', url.toString())
  }

  // функция для обновления URL при открытии ассистента (для использования в GigAssChatOpener)
  const updateUrlOnOpen = () => {
    const url = new URL(window.location.href)
    url.searchParams.set(isAssistOpen, 'true')
    window.history.replaceState({}, '', url.toString())
  }

  return {
    isOpen,
    setIsOpen: handleSetIsOpen,
    updateUrlOnOpen,
  }
}

// отдельный хук для использования в GigAssChatOpener
export const useAssistOpenUrl = () => {
  const dispatch = useAppDispatch()

  const handleOpenWithUrl = () => {
    dispatch(setChatOpen(true))

    // обновляем URL с параметром is_assist_open
    const url = new URL(window.location.href)
    url.searchParams.set('is_assist_open', 'true')
    window.history.replaceState({}, '', url.toString())
  }

  return {
    handleOpenWithUrl,
  }
}
